"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _FBUIConstants = require("../../../../utils/FBUIConstants");

var _JoinedToggleButtonModule = _interopRequireDefault(require("./JoinedToggleButton.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * # Joined Toggle Button
 * Foodbomb Adjoining Button to act like a switch
 *
 * ### Variants
 * ```
 * ['regular', 'loggedOut']
 * ```
 *
 * ## PropTypes:
 * ```js
 * JoinedToggleButton.propTypes = {
 *   buttonALabel: PropTypes.string.isRequired,
 *   buttonBLabel: PropTypes.string.isRequired,
 *   onClickButtonA: PropTypes.func.isRequired,
 *   onClickButtonB: PropTypes.func.isRequired,
 *   buttonAActive: PropTypes.bool,
 *   buttonBActive: PropTypes.bool,
 *   variant: PropTypes.string,
 *   className: PropTypes.string,
 * };
 * ```
 *
 * ## Example
 * ```js
 * <Button
 *   variant="priamry"
 *   onClick={handleClick}
 * >Sign In</Button>
 * ```
 */
var JoinedToggleButton = function JoinedToggleButton(_ref) {
  var buttonALabel = _ref.buttonALabel,
      buttonBLabel = _ref.buttonBLabel,
      onClickButtonA = _ref.onClickButtonA,
      onClickButtonB = _ref.onClickButtonB,
      buttonAActive = _ref.buttonAActive,
      buttonBActive = _ref.buttonBActive,
      variant = _ref.variant,
      className = _ref.className,
      buttonClassName = _ref.buttonClassName,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ["buttonALabel", "buttonBLabel", "onClickButtonA", "onClickButtonB", "buttonAActive", "buttonBActive", "variant", "className", "buttonClassName", "size"]);

  var primaryVariant = variant !== _FBUIConstants.JOINED_TOGGLE_BTN_VARIANTS.LOGGED_OUT ? _FBUIConstants.BUTTON_VARIANTS.SUCCESS : _FBUIConstants.BUTTON_VARIANTS.LIGHT_PRIMARY;
  var secondaryVariant = variant !== _FBUIConstants.JOINED_TOGGLE_BTN_VARIANTS.LOGGED_OUT ? _FBUIConstants.BUTTON_VARIANTS.SECONDARY : _FBUIConstants.BUTTON_VARIANTS.LIGHT_SECONDARY;
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: [_JoinedToggleButtonModule.default.JoinedToggleButtonContainer, className].join(' ')
  }, props), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onClickButtonA,
    variant: buttonAActive ? primaryVariant : secondaryVariant,
    className: [_JoinedToggleButtonModule.default.JoinedToggleButton, buttonClassName].join(' '),
    size: size
  }, buttonALabel), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onClickButtonB,
    variant: buttonBActive ? primaryVariant : secondaryVariant,
    className: [_JoinedToggleButtonModule.default.JoinedToggleButton, buttonClassName].join(' '),
    size: size
  }, buttonBLabel));
};

var _default = JoinedToggleButton;
exports.default = _default;
JoinedToggleButton.propTypes = {
  buttonALabel: _propTypes.default.string.isRequired,
  buttonBLabel: _propTypes.default.string.isRequired,
  onClickButtonA: _propTypes.default.func.isRequired,
  onClickButtonB: _propTypes.default.func.isRequired,
  buttonAActive: _propTypes.default.bool,
  buttonBActive: _propTypes.default.bool,
  variant: _propTypes.default.string,
  className: _propTypes.default.string,
  size: _propTypes.default.oneOf(Object.values(_FBUIConstants.BUTTON_SIZES)),
  buttonClassName: _propTypes.default.string
};

//# sourceMappingURL=JoinedToggleButton.js.map